import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import { PALETTES, DEFAULT_PALETTE, applyPalette } from "./palette";

const STORAGE_KEY = "crm.palette";
const CrmThemeContext = createContext(null);

export function CrmThemeProvider({ children }) {
  const scopeRef = useRef(null);
  const [paletteKey, setPaletteKey] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || DEFAULT_PALETTE; }
    catch { return DEFAULT_PALETTE; }
  });

  useEffect(() => {
    applyPalette(scopeRef.current, paletteKey);
    try { localStorage.setItem(STORAGE_KEY, paletteKey); } catch {}
  }, [paletteKey]);

  const setPalette = useCallback((key) => {
    if (PALETTES[key]) setPaletteKey(key);
  }, []);

  return (
    <CrmThemeContext.Provider value={{ paletteKey, setPalette, palettes: PALETTES }}>
      <div ref={scopeRef} className="crm-scope" style={{ minHeight: "100%", display: "flex", flexDirection: "column", flex: 1 }}>
        {children}
      </div>
    </CrmThemeContext.Provider>
  );
}

export function useCrmTheme() {
  const ctx = useContext(CrmThemeContext);
  if (!ctx) throw new Error("useCrmTheme must be used inside CrmThemeProvider");
  return ctx;
}
